import { humanizeCode } from "./pipeline";

/**
 * Dot colors, shared by the status badge and the step timeline. Same dots as
 * the other status columns (data uploads, downloads).
 */
export const DOT_COLORS = {
    success: "bg-green-600",
    danger: "bg-red-500",
    warning: "bg-orange-500",
    active: "bg-yellow-400 animate-pulse",
    neutral: "bg-neutral-400",
} as const;

export type DotTone = keyof typeof DOT_COLORS;

const STATUS_TONES: Record<string, DotTone> = {
    COMPLETE: "success",
    ERROR: "danger",
    TIMED_OUT: "warning",
    IMPORTING: "active",
    READY_FOR_PROCESSING: "active",
};

export const statusTone = (status: string): DotTone =>
    STATUS_TONES[status] ?? "neutral";

export const StatusDot = ({ tone }: { tone: DotTone }) => (
    <span
        aria-hidden="true"
        className={`inline-block h-2 w-2 shrink-0 rounded-full ${DOT_COLORS[tone]}`}
    />
);

/** A data import's public status. */
export const StatusBadge = ({ status }: { status: string }) => (
    <span className="inline-flex items-center gap-2 whitespace-nowrap">
        <StatusDot tone={statusTone(status)} />
        {humanizeCode(status)}
    </span>
);
